export const getDevPrefix = (): string | undefined => {
  return process.env.REACT_APP_DEV_PREFIX;
};

export const getDevPrefixFromBkToolsUrl = (url: string): string | undefined => {
  if (url.includes('legacy.')) {
    return url.split('.')[2];
  }
};

export const getWindowUrl = (): URL => {
  return new URL(window.location.href);
};

// This is a temporary workaround – in dev we require an auth header to be set but the value doesn't matter
export const getAuthHeader = (
  windowUrl = getWindowUrl(),
): {
  Authorization?: string;
} => {
  if (windowUrl.hostname.includes('localhost') || windowUrl.hostname.includes('dev.bench.co')) {
    return { Authorization: 'Bearer dev-mode' };
  }
  return {};
};

/**
 * Examples:
 *  Dev - https://api.colingislason.legacy.dev.bench.co/au/readonly-playground/bk-ai-assistant/api/get-message-summary?businessId=85002
 *  Staging - https://api.10sheet.ca/au/readonly-playground/bk-ai-assistant/api/get-message-summary?businessId=85002
 *  Prod - https://api.bench.co/au/readonly-playground/bk-ai-assistant/api/get-message-summary?businessId=85002
 *
 * @param windowUrl
 * @param devPrefix
 * @returns
 */
export const getAUBaseUrl = (windowUrl = getWindowUrl(), devPrefix = getDevPrefix()): string => {
  if (windowUrl.hostname.includes('bktools.in.') && windowUrl.hostname.includes('legacy.')) {
    const bkToolsDevPrefix = getDevPrefixFromBkToolsUrl(windowUrl.hostname);
    const prefix = bkToolsDevPrefix ? `${bkToolsDevPrefix}.` : '';
    return `https://api.${prefix}legacy.dev.bench.co/au/readonly-playground/bk-ai-assistant`;
  }

  if (windowUrl.hostname.includes('localhost') || windowUrl.hostname.includes('dev.bench.co')) {
    const prefix = devPrefix ? `${devPrefix}.` : '';
    return `https://api.${prefix}legacy.dev.bench.co/au/readonly-playground/bk-ai-assistant`;
  }

  const result = `https://${windowUrl.hostname.replace('bktools.in.', 'api.')}`.replace(
    'app.',
    'api.',
  );
  return `${result}/au/readonly-playground/bk-ai-assistant`;
};

/**
 * Examples:
 *
 * Dev - https://api.reggisirilan.legacy.dev.bench.co/api/v1/client.json/${clientId}
 * Dev - https://api.reggisirilan.legacy.dev.bench.co/gateway/web/api/messages/${clientId}?before=${Date.now()}&clientId=${clientId}&full=true&group=BENCH&limit=15&names=feed.message.created&names=feed.message.edited&preview=false&stats=false&viewerId=${bookkeeperId}
 * Staging - https://api.10sheet.ca/api/v1/generate.json
 * Staging - https://api.10sheet.ca/gateway/web/api/messages/${clientId}?before=${Date.now()}&clientId=${clientId}&full=true&group=BENCH&limit=15&names=feed.message.created&names=feed.message.edited&preview=false&stats=false&viewerId=${bookkeeperId}
 * Prod - https://api.bench.co/api/v1/generate.json
 * Prod - https://api.bench.co/api/v1/issues.json
 * Prod - https://api.bench.co/gateway/web/api/messages/${clientId}?before=${Date.now()}&clientId=${clientId}&full=true&group=BENCH&limit=15&names=feed.message.created&names=feed.message.edited&preview=false&stats=false&viewerId=${bookkeeperId}
 *
 * @param windowUrl
 * @param devPrefix
 * @returns
 */
export const getLegacyBaseUrl = (
  windowUrl = getWindowUrl(),
  devPrefix = getDevPrefix(),
): string => {
  if (windowUrl.hostname.includes('localhost')) {
    const prefix = devPrefix ? `.${devPrefix}` : '';
    return `https://api${prefix}.legacy.dev.bench.co`;
  }
  if (windowUrl.hostname.includes('bktools.in.') && windowUrl.hostname.includes('legacy.')) {
    const bkToolsDevPrefix = getDevPrefixFromBkToolsUrl(windowUrl.hostname);
    const prefix = bkToolsDevPrefix ? `.${bkToolsDevPrefix}` : '';
    return `https://api${prefix}.legacy.dev.bench.co`;
  }
  return `https://${windowUrl.hostname.replace('bktools.in.', 'api.')}`.replace('app.', 'api.');
};
